module.exports = {"500237001":"高唐街道","500237002":"龙门街道","500237101":"庙宇镇","500237102":"大昌镇","500237103":"福田镇","500237104":"龙溪镇","500237105":"双龙镇","500237106":"官阳镇","500237107":"骡坪镇","500237108":"抱龙镇","500237109":"官渡镇","500237110":"铜鼓镇","500237111":"巫峡镇","500237200":"红椿乡","500237207":"两坪乡","500237208":"曲尺乡","500237210":"建坪乡","500237211":"大溪乡","500237214":"金坪乡","500237216":"平河乡","500237219":"当阳乡","500237222":"竹贤乡","500237225":"三溪乡","500237227":"培石乡","500237229":"笃坪乡","500237231":"邓家乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/500237.json
// module id = 2247
// module chunks = 0